export var ActionType;
(function (ActionType) {
    ActionType["SHOW"] = "SHOW";
    ActionType["HIDE"] = "HIDE";
})(ActionType || (ActionType = {}));
export var LogicType;
(function (LogicType) {
    LogicType["ALL"] = "ALL";
    LogicType["ANY"] = "ANY";
})(LogicType || (LogicType = {}));
export var Operator;
(function (Operator) {
    Operator["IS"] = "IS";
    Operator["IS_NOT"] = "IS_NOT";
    Operator["LESS_THAN"] = "LESS_THAN";
    Operator["GREATER_THAN"] = "GREATER_THAN";
    Operator["CONTAINS"] = "CONTAINS";
    Operator["STARTS_WITH"] = "STARTS_WITH";
    Operator["ENDS_WITH"] = "ENDS_WITH";
})(Operator || (Operator = {}));
//# sourceMappingURL=GravityFormInterfaces.js.map